// test2925
(2925 && 0);
